<template>
  <v-container fluid class="user-list" v-if="languageData.labels">
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong v-html="snackbar.title"></strong>
          </div>
          <div v-html="snackbar.text"></div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-row class="ma-0">
      <v-card elevation="0" width="100%" class="ma-1 px-3 py-5">
        <v-card-text>
          <v-row no-gutters>
            <div class="top-section-wrapper">
                <div class="filter-container">
                  <v-select
                      :label="languageData.labels.select_project"
                      v-model="project"
                      :items="getProjectsToSelect"
                      item-value="id"
                      item-text="name"
                      outlined
                      hide-details
                      @change="filtersTimeReport"
                      return-object>
                    <template slot='selection' slot-scope='{ item }'>
                      {{ item.name  }}
                    </template>
                    <template slot='item' slot-scope='{ item }'>
                      {{ item.name  }}
                    </template>
                  </v-select>
              </div>
              <div class="add-button-container">     
                <v-btn height="55px" width="100%" to="/projects/time-reports/add" color="primary" class="search-button">
                  <v-icon class="mr-2">mdi-plus</v-icon>
                  {{ languageData.btnAddTimeReport }}
                </v-btn>
              </div>
            </div>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-data-table
            loading-text="Loading... Please wait"
            class="users-table"
            :headers="headers"
            :loading="loadingReports"
            :options.sync="pagination"
            :server-items-length="totalItems"
            :items-per-page-options="rowsPerPageItems"
            :footer-props="footerOptions"
            :items="dataReceive"
            :page.sync="currentPage"
            mobile-breakpoint="0"
            >
            <template v-slot:item.logo="{ item }">
              <v-avatar :color="item.hexColor" size="40" class="mr-2" style="cursor: pointer" @click="showTimeReport(item.id)">
                <span class="white--text headline">{{ getFirstLetter(item.project_name) }}</span>
              </v-avatar>
            </template>
            <template v-slot:item.total="{ item }">
              {{ item.total + '€' }}
            </template>
            <template v-slot:item.actions="{ item }">
              <td class="justify-center"> 
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="showTimeReport(item.id)"
                        icon>
                      <v-icon color="fontDefault">preview</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ languageData.labels.preview }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="showTimeReportPersons(item)"
                        icon>
                      <v-icon color="fontDefault">mdi-email-send</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ languageData.labels.choosePersonAndSend }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="showTimeReportEmailForm(item)"
                        icon>
                      <v-icon color="fontDefault">mdi-email-edit</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ languageData.labels.typeEmail }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        @click="showTimeReportsSummaryTableModal(item)"
                        :disabled="item.isConfirmed"
                        :class="{ 'before-confirm': !item.isConfirmed, 'after-confirm': item.isConfirmed }"
                        icon>
                      <v-icon color="fontDefault">summarize</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ languageData.labels.summary }}</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-row>
    <ModalInfo  :typeInfo="modalSaveInfoData.typeInfo" :headModal="modalSaveInfoData.head" :btnAgreeText="languageData.btnAgreeText" @clicked="hideModalSaveInfo" :show-modal="isShowSaveModalInfo" :text-modal="modalSaveInfoData.textInfo"></ModalInfo>

    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="updateVisibleTimeReportClientPersonsModal" :show-modal="isShowTimeReportClientPersonsModal">
      <template v-slot:header>
        {{ languageData.labels.sendTimeReport }}
      </template>
      <template v-slot:body>
        <template>
          <ClientPersonsList :clientPersons="clientPersons" layout="timeReport"></ClientPersonsList>
        </template>
        <template>
          <p class="favorite-contacts-header">{{ languageData.favoriteContacts}}</p>
          <FavoriteContactsTable layout="sendEmail" emailType="timeReport"></FavoriteContactsTable>
        </template>
      </template>
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalForm'" @clicked="updateVisibleTimeReportSendEmailModal" :show-modal="isShowTimeReportSendEmailModal">
      <template v-slot:header>
        {{ languageData.labels.sendTimeReport }}
      </template>
      <template v-slot:body>
        <SendEmailForm></SendEmailForm>
      </template>
    </ModalInfo>
  </v-container>
</template>


<script type="text/javascript">
import { mapState, mapActions } from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import router from "../../../../../router";
import FavoriteContactsTable from "../../../Company/components/FavoriteContacts/FavoriteContactsTable.vue";
import ClientPersonsList from "../../../Clients/components/ClientPersonsList/ClientPersonsList.vue";
import SendEmailForm from "../SendEmailForm/SendEmailForm.vue";

export default {
  name: "ProjectTimeReportsTable",
  data() {
    return {
      currentPage: 1,
      footerOptions: {
        'items-per-page-options': [20, 50, 100],
        'disablePagination': false
      },
      modalSaveInfoData: {},
      isShowSaveModalInfo: false,
      project: {
        id: null
      },
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: null,
        text: null,
        corner: null,
        timeout: 1000,
        title: null,
        visible: false
      }
    }
  },
  components: {
    ModalInfo, FavoriteContactsTable, ClientPersonsList, SendEmailForm
  },
  methods: {
    ...mapActions("getTimeReports", ["getTimeReports", "getHeadersTable"]),
    ...mapActions("getProjects", ["getProjects"]),
    ...mapActions("updateVisibleTimeReportClientPersonsModal", ["updateVisibleTimeReportClientPersonsModal"]),
    ...mapActions("updateVisibleTimeReportSendEmailModal", ["updateVisibleTimeReportSendEmailModal"]),
    ...mapActions("sendTimeReport", ["prepareTimeReport"]),
    ...mapActions("getTimeReportClientPersons", ["getTimeReportClientPersons"]),
    ...mapActions("updateVisibleTimeReportSummaryTableModal", ["updateVisibleTimeReportSummaryTableModal"]),
    ...mapActions("getHeadersTimeReportSummary", ["getHeadersTimeReportSummaryRequest"]),

    filtersTimeReport: function() {
      this.searchTimeReports({}, true);
    },
    searchTimeReports: function(valueSearch={}, filters=false) {
      valueSearch.filters = filters;
      valueSearch.projectId = null;
      if(this.project["value"] === undefined) {
        valueSearch.projectId = this.project["id"];
      }
      this.getTimeReports({ valueSearch });
      if(filters) {
        this.currentPage = 1;
      }
    },
    getFirstLetter: function(firstname) {
      return firstname.charAt(0);
    },
    hideModalSaveInfo: function() {
      this.isShowSaveModalInfo = false;
    },
    showTimeReport: function(id) {
      router.push({ path:"/projects/time-reports/preview" , query: { timeReportId: id } });
    },
    getSnackBar: function(title, message, icon, color) {
      this.snackbar = {
        color: color,
        icon: icon,
        mode: "multi-line",
        position: "top",
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    },
    showTimeReportPersons(item) {
      this.getTimeReportClientPersons({ creds: { id: item.id } });
      this.prepareTimeReport(item)
      this.updateVisibleTimeReportClientPersonsModal(true);
    },
    showTimeReportEmailForm(item) {
      this.prepareTimeReport(item)
      this.updateVisibleTimeReportSendEmailModal(true);
    },
    showTimeReportsSummaryTableModal(timeReport) {
      this.getHeadersTimeReportSummaryRequest();
      this.updateVisibleTimeReportSummaryTableModal({
        isModalVisible: true,
        timeReport: timeReport,
      })
    }
  },
  mounted() {
    eventBus.$on("setDisablePagination", (value) => {
      this.footerOptions["disablePagination"] = value;
    })
    if(localStorage.getItem("textTimeReportSave")) {
      this.modalSaveInfoData.typeInfo = "success";
      this.modalSaveInfoData.textInfo = localStorage.getItem("textTimeReportSave");
      this.modalSaveInfoData.head = localStorage.getItem("messageTimeReportSave");
      this.isShowSaveModalInfo = true;
      localStorage.removeItem("textTimeReportSave");
      localStorage.removeItem("messageTimeReportSave");
    }
    eventBus.$on("saveTimeReportSuccess", () => {
      this.searchTimeReports();
    })
    this.updateLanguage(this.getCurrentLanguage);
    eventBus.$on("changeLanguage", (value) => {
      const language = value;
      this.getHeadersTable({creds: {language}});
    });
    let language = this.getCurrentLanguage;
    this.getHeadersTable({ creds: {language} });

    this.getProjects();

    eventBus.$on("sendTimeReportFailure", (snackbarData) => {
      this.getSnackBar(snackbarData.title, snackbarData.message, "check_circle", "red");
    });

    eventBus.$on("confirmTimeReportSummarySuccess", () => {
      if (this.$route.name === 'ProjectTimeReports') {
        this.searchTimeReports();
      }   
    })
  },
  computed: {
    ...mapState("getTimeReports", {
      headers: state => state.headers,
      dataReceive: state => state.dataReceive,
      totalItems: state => state.pagination.totalItems,
      rowsPerPageItems: state => state.pagination.rowsPerPage,
      sortBy: state => state.pagination.sortBy,
      loadingReports: state => state.loadingReports
    }),
    ...mapState("getProjects", {
      projects: state => state.dataReceive
    }),
    ...mapState("updateVisibleTimeReportClientPersonsModal", {
      isShowTimeReportClientPersonsModal: state => state.isShowTimeReportClientPersonsModal
    }),
    ...mapState("updateVisibleTimeReportSendEmailModal", {
      isShowTimeReportSendEmailModal: state => state.isShowTimeReportSendEmailModal
    }),
    ...mapState("getTimeReportClientPersons", {
      clientPersons: state => state.clientPersons
    }),
    getProjectsToSelect: function() {
      let all = [
        {
          name: "Alle",
          id: null,
          value: null
        }
      ];
      return all.concat(this.projects);
    },
    pagination: {
      set: function(value) {
        this.searchTimeReports(value);
      },
      get: function() {
        return this.$store.state.getTimeReports.pagination;
      }
    }
  },
  beforeDestroy() {
      eventBus.$off('sendTimeReportFailure');
  }
}
</script>